export const RELATED_COMPARE_PAGES_LIST_ID = 'hub_page_related_compare_pages'
export const COMPARE_PAGE_RELATED_ARTICLES_LIST_ID = 'cp_related_articles'
export const COMPARE_PAGE_RELATED_COMPARE_PAGES_LIST_ID =
  'cp_related_compare_pages'
